import * as config from "../config";
import { experiments } from "../index";

export function useActiveVariant<T extends keyof typeof config.experiments>(
  experimentName: T,
) {
  let variant = experiments.getVariant(experimentName);

  if (!variant) {
    variant = experiments.coinFlip(experimentName);
    experiments.setVariant(experimentName, variant);
  }

  return variant;
}
